<template>
    <b-modal
        :hide-footer="true"
        title="Atualização da Concessão de Benefício"
        centered
        size="md"
        id="atualizar-status-beneficio"
        :visible="false"
        :no-close-on-backdrop="true"
    >
        <div class="row">
            <form class="col-12" @submit.prevent="submit">
                <div class="row">
                    <form-calendar
                        :max-date="dataNow"
                        v-model="data"
                        label="Data da atualização"
                        :required="true"
                    />
                    <form-textarea
                        v-model="observacoes"
                        label="Observação sobre a atualização do status"
                        :required="true"
                    />
                </div>

                <div class="row pt-1 px-2 d-flex justify-content-end">
                    <button type="submit" class="btn btn-success btn-submit">
                        <i class="mdi mdi-content-save" /> {{ $t("Salvar") }}
                    </button>
                </div>
            </form>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: ["beneficio", "statusAnterior"],
    data() {
        return {
            dataNow: moment().format("YYYY/MM/DD"),
            status: "",
            data: "",
            observacoes: "",
        };
    },
    mounted() {
        axios.get(`api/account/getuser`).then((response) => {
            this.user = response.data;
        });
    },
    methods: {
        submit() {
            // this.data = moment(this.data, "YYYY-MM-DD").format("DD/MM/YYYY");

            axios
                .post("api/dashboard/status/historico", {
                    id: this.beneficio.id,
                    observacoes: this.observacoes,
                    status_anterior: this.statusAnterior,
                    status_atual: this.beneficio.status_liberacao,
                    data: this.data,
                    module: "Beneficio",
                    model: "BeneficioLiberado",
                })
                .then((response) => {
                    this.$emit("submit", "historico");
                    this.$snack.success({
                        button: false,
                        text: "Histórico salvo com sucesso.",
                    });
                    this.load = false;
                })
                .finally(() => {
                    this.observacoes = "";
                    this.data = "";

                    this.$bvModal.hide("atualizar-status-beneficio");
                });
        },
    },
};
</script>
